import { Attr, HasOne, Model } from "spraypaint";

import type {
  InsightsLandingPageItemTargetClass,
  InsightsLandingPageItemTargetString,
} from "shared/modules/Insights/types";
import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class Favorite extends ApplicationRecord {
  static jsonapiType = "favorites";

  @Attr() createdAt: string;

  @HasOne() target: InsightsLandingPageItemTargetClass;

  @Attr() targetId: number;

  @Attr() targetType: InsightsLandingPageItemTargetString;

  @Attr() userId: number;
}

export default Favorite;
